import * as React from 'react';
import { Modal, ModalBody } from 'reactstrap';

interface IModalLegalProps {
  open: boolean;
  toggle: any;
}

export default function ModalCoverage(props: IModalLegalProps) {
  const { open = true, toggle } = props;

  return (
    <Modal modalClassName="format-new-modal" isOpen={open} size="lg" fade={false}>
      <div className="modal-header">
        <div className="close-modal-header w-100 d-flex text-align-left justify-content-between">
            <img
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_chevron.svg"
                alt=""
                onClick={toggle(false)}
            />
            <img 
                src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Action%20Group.svg"
                alt=""
                onClick={toggle(false)}
            />
        </div>
        <h4 className="modal-title px-20">Que cubre</h4>
      </div>
      <ModalBody className="px-16">
        <p>Gastos generales:</p>
        <ul>
            <li>Consulta médica (plan con consulta).</li>
            <li>Cirugía ambulatoria.</li>
            <li>Exámenes ambulatorios.</li>
            <li>Procedimientos de diagnóstico.</li>
            <li>Procedimientos quirúrgicos.</li>
        </ul>
        <p>Gastos hospitalarios:</p>
        <ul>
            <li>Día cama.</li>
            <li>Servicios hospitalarios.</li>
            <li>Honorarios médicos.</li>
            <li>Insumos.</li>
            <li>Ambulancia.</li>
        </ul>
        <p>Maternidad:</p>
        <ul>
            <li>Parto normal.</li>
            <li>Cesárea.</li>
            <li>Aborto no provocado.</li>
        </ul>
        <p>Salud mental:</p>
        <ul>
            <li>Sólo para planes con consulta: consulta psiquiátrica y psicológica.</li>
        </ul>
      </ModalBody>
    </Modal>
  );
}
